export const ARROW_LEFT = 37;
export const ARROW_RIGHT = 39;
export const HOME = 36;
export const END = 35;
